(function (Drupal) {
  Drupal.behaviors.viewDayHealth = {
    attach: function (context, settings) {
      
      const viewDayHealth = document.querySelector(".view-day-healt, .view-investigation-education", context); 

      if (viewDayHealth) {
        const formItemCreatedMin = viewDayHealth.querySelector(".js-form-item-created-min", context);
        const formItemCreatedMax = viewDayHealth.querySelector(".js-form-item-created-max", context);

        if (formItemCreatedMin && formItemCreatedMax) {
          const labelMin = formItemCreatedMin.querySelector("label", context);
          const labelMax = formItemCreatedMax.querySelector("label", context);

          if (labelMin && labelMax) {
            labelMin.textContent = "Fecha desde";
            labelMax.textContent = "Fecha hasta";
          }
        }
        document.querySelectorAll('.views-complex-grouping-leave').forEach(group => {
          const firstCard = group.querySelector('.card.card-investigation-main');
          
          if (firstCard) {
            const dataTid = firstCard.getAttribute('data-tid');        
            const newButton = document.createElement('a');
            newButton.textContent = 'Ver todo';
            newButton.classList.add("see-more");
            newButton.onclick = () => {
              window.location.href = dataTid;
            };
        
            const firstH3 = group.querySelector('h3');
        
            if (firstH3) {
              firstH3.appendChild(newButton);
            }
          }
        });
      }
      
      const isMobileSafari = /iPhone|iPad|iPod/.test(navigator.userAgent) && 
                       /Safari/.test(navigator.userAgent) && 
                       !/Chrome/.test(navigator.userAgent) && 
                       !/CriOS/.test(navigator.userAgent);

      const isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent);

      const isAndroid = /Android/i.test(navigator.userAgent);  
         
      if (isMobileSafari || isSafari || isAndroid) {        
        document.querySelector("body").classList.add("safari");
        const dateInputs = document.querySelectorAll('input[type="date"]');                       
        if (dateInputs) {
          const placeholderText = 'DD/MM/AAAA';
      
          dateInputs.forEach((dateInput) => {
            //dateInput.classList.add("font-zero");
            showPlaceholder(dateInput);
            dateInput.setAttribute('data-placeholder', placeholderText);
            dateInput.setAttribute('placeholder', placeholderText);
            dateInput.addEventListener('input', () => {
              showPlaceholder(dateInput);
            });
            dateInput.addEventListener('focus', () => {
              showPlaceholder(dateInput);
            });
            dateInput.addEventListener('blur', () => {
              showPlaceholder(dateInput);
            });
  
          });
          /**
           * Function to handle showing/hiding the placeholder
           * @param {HTMLElement} dateInput - The date input element
           */
          function showPlaceholder(dateInput) {            
            if (dateInput.value === '') {
              dateInput.classList.remove("value-in")
              dateInput.classList.remove("font-zero")
              dateInput.setAttribute('placeholder', placeholderText);
            } else {
              dateInput.classList.add("value-in")
              dateInput.classList.remove("font-zero")
              dateInput.removeAttribute('placeholder');
            }
          }
        }
      }   
    }
  };
})(Drupal);